/**
 * Web Font Loader takes care of Vue Design System’s font loading.
 * For full documentation, see: https://github.com/typekit/webfontloader
 */
import WebFont from 'webfontloader'

WebFont.load({
  google: {
    families: ['Rubik:300,400,700,900', 'Georgia,sans-serif:300,400,700', 'Space+Mono:400,700']
  }
})
